import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6699699e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-header__titleWrap" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page-header__title" }, "Đăng ký tài khoản nhân viên")
  ])
], -1))
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1))
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tên đăng nhập", -1))
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1))
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1))
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn quyền hạn", -1))
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng", -1))
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { class: "page-panel" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            id: "fullname",
            type: "text",
            modelValue: $setup.register.fullname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.register.fullname) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_InputText, {
            id: "username",
            type: "text",
            modelValue: $setup.register.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register.username) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Password, {
            id: "password",
            modelValue: $setup.register.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.register.password) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputText, {
            id: "phoneNumber",
            type: "text",
            modelValue: $setup.register.phoneNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.register.phoneNumber) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_Dropdown, {
            id: "permission",
            modelValue: $setup.register.permission,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.register.permission) = $event)),
            options: $setup.userPermission,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Vui lòng chọn quyền hạn của tài khoản ..."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_Dropdown, {
            id: "khoaPhong",
            modelValue: $setup.register.idKhoaPhong,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.register.idKhoaPhong) = $event)),
            options: $setup.khoaPhong,
            optionLabel: "tenKhoaPhong",
            optionValue: "id",
            placeholder: "Vui lòng chọn khoa phòng nhận ..."
          }, null, 8, ["modelValue", "options"]),
          ($setup.register.idKhoaPhong < 1)
            ? (_openBlock(), _createElementBlock("small", _hoisted_15, "Vui lòng chọn khoa phòng"))
            : _createCommentVNode("", true)
        ])
      ]),
      ($setup.valid)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            style: {"margin-bottom":"20px"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.doRegister()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            style: {"margin-bottom":"20px"},
            disabled: "disabled"
          }))
    ]),
    _: 1
  }))
}